export const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
}

export const getters = {}

export const mutations = {
  TOGGLE_SIDEBAR_DESKTOP(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  TOGGLE_SIDEBAR_MOBILE(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  SET_SIDEBAR_STATE(state, [variable, value]) {
    state[variable] = value
  },
}

export const actions = {}
